'use strict';

var React = require('react');

var SvgPaginationStartMinor = function SvgPaginationStartMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.75 5.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0v-8.5Zm7.796.514a.75.75 0 1 0-1.092-1.028l-4 4.25a.75.75 0 0 0 0 1.028l4 4.25a.75.75 0 1 0 1.092-1.028l-3.516-3.736 3.516-3.736Z"
  }));
};
SvgPaginationStartMinor.displayName = "PaginationStartMinor";

exports.SvgPaginationStartMinor = SvgPaginationStartMinor;
